import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from "@/mixins/infoList";
import { addHitList, delFromHitList, getHitListType, queryCancelStaticQr, showHitList } from "@/api/payment";
export default {
  name: "backList",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: showHitList,
      typeStr: '',
      signStr: '',
      typeObj: {},
      signObj: {},
      delList: [],
      addList: [{
        context: '',
        sign: -1,
        type: -1,
        signStr: '',
        typeStr: ''
      }],
      addVisible: false,
      cancelQrData: {
        appName: '',
        uid: ''
      },
      cancelQrVisible: false
    };
  },
  methods: {
    delMessage: function delMessage() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var list, i, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              list = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
              if (list !== 1) {
                _this.delList.push(list);
              }
              for (i = 0; i < _this.delList.length; i++) {
                _this.delList[i]['sign'] = _this.searchOption(_this.signObj, _this.delList[i]['sign']);
                _this.delList[i]['type'] = _this.searchOption(_this.typeObj, _this.delList[i]['type']);
              }
              _context.next = 1;
              return delFromHitList({
                list: _this.delList
              });
            case 1:
              res = _context.sent;
              if (!(res.code === 0)) {
                _context.next = 2;
                break;
              }
              _this.delList = [];
              _this.$message.success(res.msg);
              _context.next = 2;
              return _this.getTableData();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    addFromHitList: function addFromHitList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var hitList, i, res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              hitList = _this2.addList;
              for (i = 0; i < hitList.length; i++) {
                delete hitList[i].typeStr;
                delete hitList[i].signStr;
              }
              _context2.next = 1;
              return addHitList({
                list: hitList
              });
            case 1:
              res = _context2.sent;
              if (!(res.code === 0)) {
                _context2.next = 2;
                break;
              }
              _this2.addVisible = false;
              _this2.$message.success(res.msg);
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openCancelQrDialog: function openCancelQrDialog() {
      this.cancelQrData.appName = '';
      this.cancelQrData.uid = '';
      this.cancelQrVisible = true;
    },
    confirmCancelQr: function confirmCancelQr() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this3.$confirm("\u4F60\u5C06\u8981\u4E3A\u53D6\u6D88".concat(_this3.cancelQrData.appName, "\u8FD9\u4E2A\u5305\u7684UserId\u4E3A").concat(_this3.cancelQrData.uid, "\u7528\u6237\u7684\u9759\u6001\u4E8C\u7EF4\u7801, \u662F\u5426\u7EE7\u7EED?"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var res;
                return regeneratorRuntime.wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 1;
                      return queryCancelStaticQr(_this3.cancelQrData);
                    case 1:
                      res = _context3.sent;
                      if (res.code === 0) {
                        if (res.msg === '成功取消该二维码') {
                          _this3.$message.success(res.msg);
                        } else {
                          _this3.$message.error(res.msg);
                        }
                        _this3.cancelQrVisible = false;
                      }
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }))).catch(function () {
                _this3.cancelQrVisible = false;
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    addBacklistDialog: function addBacklistDialog() {
      this.addList = [{
        context: '',
        sign: -1,
        type: -1,
        signStr: '',
        typeStr: ''
      }];
      this.addVisible = true;
    },
    addBackListPre: function addBackListPre() {
      var obj = {
        context: '',
        sign: -1,
        type: -1,
        signStr: '',
        typeStr: ''
      };
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].sign === -1 || this.addList[i].context === '' || this.addList[i].type === -1) {
          this.$message.warning('请填写完整信息，才能添加一下');
          return;
        }
      }
      this.addList.push(obj);
    },
    getParmp: function getParmp() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return getHitListType();
            case 1:
              res = _context5.sent;
              if (res.code === 0) {
                _this4.typeObj = res.data.payType;
                _this4.signObj = res.data.signType;
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.delList = e;
    }
  },
  created: function created() {
    this.searchInfo.type = -1;
    this.searchInfo.sign = -1;
    this.getParmp();
    this.getTableData();
  }
};